var map = {
	"./alph.wav": "5a05",
	"./banjo-and-kazooie.wav": "0359",
	"./bayonetta.wav": "9728",
	"./bowser-jr.wav": "1d8a",
	"./bowser.wav": "fc0b6",
	"./byleth.wav": "104e",
	"./captain-falcon.wav": "a5bb",
	"./chrom.wav": "4fb0",
	"./cloud.wav": "6d80",
	"./corrin.wav": "d94b",
	"./daisy.wav": "ea76",
	"./dark-pit.wav": "4b67",
	"./dark-samus.wav": "7c9f",
	"./diddy-kong.wav": "071c",
	"./donkey-kong.wav": "78cd",
	"./dr-mario.wav": "16ab",
	"./duck-hunt.wav": "9a42",
	"./falco.wav": "adc8",
	"./fox.wav": "5cc4",
	"./ganondorf.wav": "4f62",
	"./greninja.wav": "e1a9",
	"./hero.wav": "cd18",
	"./ice-climbers.wav": "eb735",
	"./iggy.wav": "56c5",
	"./ike.wav": "b79d",
	"./incineroar.wav": "3de9",
	"./inkling.wav": "7f09",
	"./isabelle.wav": "a46b",
	"./jigglypuff.wav": "68f2",
	"./joker.wav": "58b6",
	"./kazuya.wav": "463a",
	"./ken.wav": "c766",
	"./king-dedede.wav": "a9e6f",
	"./king-k-rool.wav": "cc5f",
	"./kirby.wav": "99af",
	"./larry.wav": "fdb0",
	"./lemmy.wav": "24cf",
	"./link.wav": "98f4",
	"./little-mac.wav": "4bf2",
	"./lucario.wav": "7f37",
	"./lucas.wav": "6e64",
	"./lucina.wav": "ea9a",
	"./ludwig.wav": "9863",
	"./luigi.wav": "3d24",
	"./mario.wav": "3f50",
	"./marth.wav": "89bd",
	"./mega-man.wav": "4018",
	"./meta-knight.wav": "8cd7",
	"./mewtwo.wav": "1b90",
	"./mii-brawler.wav": "0ccc",
	"./mii-gunner.wav": "4635",
	"./mii-swordfighter.wav": "e334",
	"./min-min.wav": "27fb",
	"./morton.wav": "02bf",
	"./mr-game-and-watch.wav": "4bb9",
	"./mythra.wav": "573e",
	"./ness.wav": "d1a1",
	"./olimar.wav": "c7a8",
	"./pac-man.wav": "45a59",
	"./palutena.wav": "5e30",
	"./peach.wav": "b9f5",
	"./pichu.wav": "b8b1",
	"./pikachu.wav": "8621",
	"./piranha-plant.wav": "33bd",
	"./pit.wav": "df5c",
	"./pokemon-trainer.wav": "955f",
	"./pyra-and-mythra.wav": "03e2",
	"./richter.wav": "5bf1",
	"./ridley.wav": "1b0d",
	"./rob.wav": "59ea",
	"./robin.wav": "530e",
	"./rosalina-and-luma.wav": "270a",
	"./roy.wav": "bb55",
	"./ryu.wav": "b41f",
	"./samus.wav": "6d98",
	"./sephiroth.wav": "25d9",
	"./sheik.wav": "470f",
	"./shulk.wav": "0efd",
	"./simon.wav": "0932",
	"./snake.wav": "6606",
	"./sonic.wav": "c1d4",
	"./sora.wav": "129e",
	"./steve.wav": "6656",
	"./terry.wav": "9eb6",
	"./toon-link.wav": "bcc9",
	"./villager.wav": "4224",
	"./wario.wav": "a777",
	"./wendy.wav": "411d",
	"./wii-fit-trainer.wav": "6205",
	"./wolf.wav": "b954",
	"./yoshi.wav": "1f9f",
	"./young-link.wav": "70f6",
	"./zelda.wav": "43ec",
	"./zero-suit-samus.wav": "1202"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a20";